import { Article } from '../../types'

export const MOCK_LATEST_ARTICLES: Article[] = [
  {
    source: {
      name: 'Newsweek',
    },
    title:
      'Video Appears to Show Russian Soldiers Attacking With Wooden Sticks',
    author: 'Brendan Cole',
    url: 'https://www.newsweek.com/russian-soldiers-using-sticks-bakhmut-video-1787578',
    urlToImage:
      'https://d.newsweek.com/en/full/2208442/ukrainian-serviceman-bakhmut.jpg',
    publishedAt: '2023-03-14T12:07:16Z',
  },
  {
    source: {
      name: 'New Scientist',
    },
    title:
      'Ecologists are infecting trees with fungi to make them age prematurely',
    author: 'Graham Lawton',
    url: 'https://www.newscientist.com/article/2364205-ecologists-are-infecting-trees-with-fungi-to-make-them-age-prematurely/',
    urlToImage:
      'https://images.newscientist.com/wp-content/uploads/2023/03/14115419/SEI_147701419.jpg',
    publishedAt: '2023-03-14T12:06:51Z',
  },
  {
    source: {
      name: 'TechRadar',
    },
    title:
      "We may know everything about the Google Pixel 7a before it's even been announced",
    author: 'hamish.hector@futurenet.com (Hamish Hector)',
    url: 'https://www.techradar.com/news/we-may-know-everything-about-the-google-pixel-7a-before-its-even-been-announced',
    urlToImage:
      'https://cdn.mos.cms.futurecdn.net/RHAtQgqFYu7bLmGxiEap97-1200-80.jpg',
    publishedAt: '2023-03-14T12:06:03Z',
  },
  {
    source: {
      name: 'BBC News',
    },
    title: '2023/03/14 12:00 GMT',
    author: null,
    url: 'https://www.bbc.co.uk/programmes/w172ykqlrw70665',
    urlToImage: 'https://ichef.bbci.co.uk/images/ic/1200x675/p060dh18.jpg',
    publishedAt: '2023-03-14T12:06:00Z',
  },
  {
    source: {
      name: 'Independent',
    },
    title:
      'F1 news LIVE: London Grand Prix pitched in ambitious plans for new British race',
    author: 'Kieran Jackson',
    url: 'https://www.independent.co.uk/f1/f1-latest-news-london-grand-prix-b2300475.html',
    urlToImage:
      'https://static.independent.co.uk/2023/03/14/11/Screen%20Shot%202023-03-14%20at%2011.47.31.png?quality=75&width=1200&auto=webp',
    publishedAt: '2023-03-14T12:04:14Z',
  },
  {
    source: {
      name: 'Independent',
    },
    title:
      '2026 World Cup set to include a new last-32 stage in extended tournament',
    author: 'Jamie Gardner',
    url: 'https://www.independent.co.uk/sport/football/qatar-mexico-canada-united-states-rwanda-b2300488.html',
    urlToImage:
      'https://static.independent.co.uk/2023/03/14/12/d8b57931c94c81748a8ed63e3a392bf0Y29udGVudHNlYXJjaGFwaSwxNjc4ODgwNzI0-2.70328808.jpg?quality=75&width=1200&auto=webp',
    publishedAt: '2023-03-14T12:03:53Z',
  },
  {
    source: {
      name: 'TechCrunch',
    },
    title:
      'Mars-backed Bundle x Joy bags $1M to double its pet care footprint in retailers',
    author: 'Christine Hall',
    url: 'https://techcrunch.com/2023/03/14/bundle-x-joy-pet-care-commerce/',
    urlToImage:
      'https://techcrunch.com/wp-content/uploads/2023/03/Copy-of-BundlexJoy0709.jpg?resize=1200,675',
    publishedAt: '2023-03-14T12:03:18Z',
  },
  {
    source: {
      name: 'ABC News',
    },
    title: "Nigeria's old currency can be used longer amid cash crisis",
    author: 'CHINEDU ASADU Associated Press',
    url: 'https://abcnews.go.com/Business/wireStory/nigerias-currency-longer-amid-cash-crisis-97846414',
    urlToImage:
      'https://s.abcnews.com/images/International/wirestory_36674c8e949af512813b888e78611063_16x9_992.jpg',
    publishedAt: '2023-03-14T12:03:07Z',
  },
  {
    source: {
      name: 'USA Today',
    },
    title: "Five teams that can bust your men's NCAA Tournament bracket",
    author: 'USA TODAY, Lindsay Schnell, USA TODAY',
    url: 'https://www.usatoday.com/story/sports/ncaab/2023/03/14/mens-ncaa-tournament-top-potential-bracket-busters/11467217002/',
    urlToImage:
      'https://www.gannett-cdn.com/presto/2023/03/14/USAT/e2c6ec4d-cf98-483b-a404-fd9c1e42b1b7-USATSI_20203899.jpg?auto=webp&crop=2636,1483,x140,y0&format=pjpg&width=1200',
    publishedAt: '2023-03-14T12:02:57Z',
  },
  {
    source: {
      name: 'BBC News',
    },
    title: 'Wales name four uncapped players in squad',
    author: null,
    url: 'https://www.bbc.co.uk/sport/football/64951165',
    urlToImage:
      'https://ichef.bbci.co.uk/live-experience/cps/624/cpsprodpb/FCC4/production/_128980746_clubkits.png',
    publishedAt: '2023-03-14T12:02:54Z',
  },
  {
    source: {
      name: 'Business Insider',
    },
    title:
      'First Republic leads a comeback for bank stocks that cratered in the SVB-fueled selloff',
    author: 'gglover@insider.com (George Glover)',
    url: 'https://markets.businessinsider.com/news/stocks/first-republic-stock-price-western-alliance-svb-silicon-valley-bank-2023-3',
    urlToImage:
      'https://i.insider.com/6410538bf724e7001800de79?width=1200&format=jpeg',
    publishedAt: '2023-03-14T12:02:50Z',
  },
  {
    source: {
      name: 'ABC News',
    },
    title: 'Armenian PM critical of Moscow-dominated security pact',
    author: 'AVET DEMOURIAN Associated Press',
    url: 'https://abcnews.go.com/Business/wireStory/armenian-pm-critical-moscow-dominated-security-pact-97845817',
    urlToImage:
      'https://s.abcnews.com/images/International/wirestory_63114ddfa71aaf1f0e7bb6e16a6d4643_16x9_992.jpg',
    publishedAt: '2023-03-14T12:02:50Z',
  },
  {
    source: {
      name: 'ABC News',
    },
    title: "Nigeria's old currency can be used longer amid cash crisis",
    author: 'CHINEDU ASADU Associated Press',
    url: 'https://abcnews.go.com/International/wireStory/nigerias-currency-longer-amid-cash-crisis-97846413',
    urlToImage:
      'https://s.abcnews.com/images/International/wirestory_36674c8e949af512813b888e78611063_16x9_992.jpg',
    publishedAt: '2023-03-14T12:02:47Z',
  },
  {
    source: {
      name: 'Independent',
    },
    title: 'Pakistan police, ex-PM Khan supporters scuffle near his home',
    author: 'Munir Ahmed',
    url: 'https://www.independent.co.uk/news/imran-khan-ap-islamabad-shahbaz-sharif-pakistan-b2300485.html',
    urlToImage:
      'https://static.independent.co.uk/2023/03/08/14/Pakistan-Politics_81163.jpg?quality=75&width=1200&auto=webp',
    publishedAt: '2023-03-14T12:01:50Z',
  },
  {
    source: {
      name: 'Independent',
    },
    title: 'When is Jeremy Hunt’s budget speech 2023?',
    author: 'Tara Cobham',
    url: 'https://www.independent.co.uk/news/uk/politics/jeremy-hunt-budget-2023-when-b2300416.html',
    urlToImage:
      'https://static.independent.co.uk/2023/03/14/00/1165299321e2853486b97732eebad64dY29udGVudHNlYXJjaGFwaSwxNjc4ODM3MDg5-2.71345160.jpg?quality=75&width=1200&auto=webp',
    publishedAt: '2023-03-14T12:01:37Z',
  },
  {
    source: {
      name: 'USA Today',
    },
    title: 'Leesa mattress has up to $700 off during Sleep Week 2023',
    author: 'Jaime Carrillo and Daniel Donabedian, Reviewed',
    url: 'https://www.usatoday.com/story/money/reviewed/2023/03/14/leesa-mattress-sale-sleep-week/11469317002/',
    urlToImage:
      'https://s.yimg.com/ny/api/res/1.2/tCDu7EVa.Tg0BpVYYB.yUg--/YXBwaWQ9aGlnaGxhbmRlcjt3PTEyMDA7aD02NzU-/https://media.zenfs.com/en/usa_today_money_325/9c572f33fbab8552a5142093def71a0e',
    publishedAt: '2023-03-14T12:01:10Z',
  },
  {
    source: {
      name: 'CNN',
    },
    title: 'What comes next in the banking crisis? The early 1990s hold clues',
    author: 'Nicole Goodkind',
    url: 'https://www.cnn.com/2023/03/14/investing/premarket-stocks-trading/index.html',
    urlToImage:
      'https://media.cnn.com/api/v1/images/stellar/prod/230313190406-silicon-valley-bank-031323.jpg?c=16x9&q=w_800,c_fill',
    publishedAt: '2023-03-14T12:01:09Z',
  },
  {
    source: {
      name: 'USA Today',
    },
    title:
      "Exclusive: Social media threats exploded after Tucker Carlson's Jan. 6 claims, analysis finds",
    author: 'USA TODAY, Jessica Guynn and Will Carless, USA TODAY',
    url: 'https://www.usatoday.com/story/tech/2023/03/14/fox-news-tucker-carlson-jan-6-social-media-violence/11445250002/',
    urlToImage:
      'https://www.gannett-cdn.com/presto/2023/03/10/USAT/1de7d6cd-a223-4ca0-a7ff-b503e7e5808a-AP_Voting_Machines_Defamation_Lawsuit.jpg?auto=webp&crop=3459,1946,x0,y176&format=pjpg&width=1200',
    publishedAt: '2023-03-14T12:01:07Z',
  },
  {
    source: {
      name: 'CNN',
    },
    title:
      'Hoy es el Día de la Igualdad Salarial. Esto es lo que eso significa',
    author: 'Melissa Velásquez Loaiza',
    url: 'https://cnnespanol.cnn.com/2023/03/14/dia-igualdad-salarial-lo-que-significa-trax/',
    urlToImage:
      'https://cnnespanol.cnn.com/wp-content/uploads/2023/03/equidad-salarial.jpeg?quality=100&strip=info',
    publishedAt: '2023-03-14T12:00:47Z',
  },
  {
    source: {
      name: 'Time',
    },
    title:
      'Conflicts of Interest Could Undermine the Cleanup Efforts in East Palestine',
    author: 'David Michaels',
    url: 'https://time.com/6262343/east-palestine-train-toxic-cleanup-conflicts-of-interest/',
    urlToImage:
      'https://api.time.com/wp-content/uploads/2023/03/east-palestine-train-derailment-testing.jpg?quality=85&w=1024&h=628&crop=1',
    publishedAt: '2023-03-14T12:00:41Z',
  },
  {
    source: {
      name: 'Fox News',
    },
    title: "Why Biden's choice for Labor Secretary boggles my mind",
    author: 'Aaron Withe',
    url: 'https://www.foxnews.com/opinion/bidens-choice-labor-secretary-boggles-mind',
    urlToImage:
      'https://static.foxnews.com/foxnews.com/content/uploads/2023/02/GettyImages-1390926117.jpg',
    publishedAt: '2023-03-14T12:00:29Z',
  },
  {
    source: {
      name: 'IGN',
    },
    title:
      '¿El lanzamiento de Diablo IV se producirá en Xbox Game Pass? El director del juego comenta que "no hay planes"',
    author: 'Yinyangfooey, Estrella Gomez',
    url: 'https://es.ign.com/diablo-iv/189072/news/el-lanzamiento-de-diablo-iv-se-producira-en-xbox-game-pass-el-director-del-juego-comenta-que-no-hay',
    urlToImage:
      'https://sm.ign.com/t/ign_es/news/d/diablo-4-d/diablo-4-director-says-no-plans-for-xbox-game-pass-as-beta-a_phqp.1200.jpg',
    publishedAt: '2023-03-14T12:00:29Z',
  },
  {
    source: {
      name: 'TechCrunch',
    },
    title:
      'Cloud security vendor Mitiga lands $45M, valuing the company at over $100M',
    author: 'Kyle Wiggers',
    url: 'https://techcrunch.com/2023/03/14/mitiga-raises-45m-for-cloud-security/',
    urlToImage:
      'https://techcrunch.com/wp-content/uploads/2023/02/GettyImages-1334236014.jpg?resize=1200,804',
    publishedAt: '2023-03-14T12:00:29Z',
  },
  {
    source: {
      name: 'TechRadar',
    },
    title:
      'Razr 2023 leak suggests it could be Motorola’s most fun foldable yet',
    author: 'mark.wilson@futurenet.com (Mark Wilson)',
    url: 'https://www.techradar.com/news/razr-2023-leak-suggests-it-could-be-motorolas-most-fun-foldable-yet',
    urlToImage:
      'https://cdn.mos.cms.futurecdn.net/5sf6uRxawxTZ9SHdmJ5hiW-1200-80.jpg',
    publishedAt: '2023-03-14T12:00:23Z',
  },
  {
    source: {
      name: 'MSNBC',
    },
    title: 'Why Republicans’ fixation on ‘woke’ banking is so unsettling',
    author: 'Steve Benen',
    url: 'https://www.msnbc.com/rachel-maddow-show/maddowblog/republicans-fixation-woke-banking-unsettling-rcna74820',
    urlToImage:
      'https://media-cldnry.s-nbcnews.com/image/upload/t_nbcnews-fp-1200-630,f_auto,q_auto:best/rockcms/2023-03/230313-silicon-valley-bank-se-420p-3efaaf.jpg',
    publishedAt: '2023-03-14T12:00:22Z',
  },
]
